import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utility/imageHelper";
import { slugify } from "../utility/slugify";
import { useCart } from "../context/CartContext";
import { useAnalytics } from "../context/AnalyticsProvider";
import "./styles/ProductCard.css";

const ProductCard = ({ product, listName, index_position, showId }) => {
  const { addToCart, cart } = useCart();
  const [added, setAdded] = useState(false);
  const [maxStockReached, setMaxStockReached] = useState(false);

  const analytics = useAnalytics();


  const isOutOfStock = product.stock <= 0;

  const cartItem = cart.find((item) => item.id === product.id);
  const quantityInCart = cartItem ? cartItem.quantity : 0;

  const [hoveredImage, setHoveredImage] = useState(
    product.images.length > 0 ? product.images[0] : null
  );
  

  useEffect(() => {
    if (quantityInCart >= product.stock) {
      setMaxStockReached(true);
    }
  }, [quantityInCart, product.stock]);

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (maxStockReached) return;


    // 🔥 Fire select_item for direct Add to Cart
    analytics.track("select_item", {
      item_list_name: listName,
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          category: product.category_name,
          stock_remaining: product.stock,
          index: index_position
        }
      ]
    });


    addToCart(product);
    analytics.track("add_to_cart", {
      currency: "USD",
      value: product.price,
      item_list_name: listName,
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          category: product.category_name,
          quantity: 1,
          stock_remaining: product.stock - (quantityInCart + 1),
          index: index_position
        }
      ]
    });
    setAdded(true);

    setTimeout(() => {
      setAdded(false);
      if (quantityInCart + 1 >= product.stock) {
        setMaxStockReached(true);
      }
    }, 4000);
  };

  return (
    <Link 
    className="product-link" 
    to={`/shop-knives/knife/${product.id}/${slugify(product.name)}`} 
    aria-label={`View details for ${product.name}`}
    onClick={() => {
      analytics.track("select_item", {
        item_list_name: listName,
        items: [
          {
            item_id: product.id,
            item_name: product.name,
            price: product.price,
            category: product.category_name,
            stock_remaining: product.stock,
            index: index_position
          }
        ]
      });
    }}
    >

      <div className="product-card">

        {/* ✅ Main Image */}
        {hoveredImage && (
          <div className="main-image-wrapper">
            <img
              src={getImageUrl(hoveredImage)}
              alt={product.name}
              className="main-product-image"
            />
          </div>

        )}

        {/* ✅ Thumbnail Images */}
        {product.images.length > 1 && (
          <div className="thumbnail-container">
            {product.images.map((img, index) => (
              <img
                key={index}
                src={getImageUrl(img)}
                alt=""
                className={`thumbnail ${
                  hoveredImage === img ? "active" : ""
                }`}
                onMouseEnter={() => setHoveredImage(img)}
                aria-hidden="true"
              />
            ))}
          </div>
        )}



        <div className="product-card-info">
          <div className="product-card-name-category">
            {/* ✅ Category */}
            {product.category_name && (
              <p className="product-card-category">{product.category_name}</p>
            )}
            <h3>
              {product.name}
              {showId && <> <span>(#{product.id})</span></>}
            </h3>

          </div>
          
          <p className="product-card-price">${product.price}</p>
        </div>

        

        

        {isOutOfStock ? (
          <button className="sold-out-button" disabled>
            <i className="fa-solid fa-box-open" aria-hidden="true"></i> Sold Out
          </button>
        ) : maxStockReached ? (
          <button className="sold-out-button" disabled>
            <i className="fa-solid fa-check" aria-hidden="true"></i> Added to Cart
          </button>
        ) : (
          <button
            className="add-to-cart"
            onClick={handleAddToCart}
            disabled={added}
          >
            {added ? (
              <>
                <i className="fa-solid fa-check" aria-hidden="true"></i> Added to Cart
              </>
            ) : (
              <>
                <i className="fa-solid fa-cart-plus" aria-hidden="true"></i> Add to Cart
              </>
            )}
          </button>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
